import { render, staticRenderFns } from "./ClassifyDispatchAssets.vue?vue&type=template&id=0a9f262d&scoped=true"
import script from "./ClassifyDispatchAssets.vue?vue&type=script&lang=js"
export * from "./ClassifyDispatchAssets.vue?vue&type=script&lang=js"
import style0 from "./ClassifyDispatchAssets.vue?vue&type=style&index=0&id=0a9f262d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9f262d",
  null
  
)

export default component.exports